module.exports = __webpack_public_path__ + "87c4741d2dc31801116e95117e8ef82c.png";